export default "__VITE_ASSET__DaxeUrNa__"